import React from 'react';
import { SeasonIcon } from './SeasonIcon';
import DayColumn from './../DayColumn/DayColumn';
import { useCalendarGroupToggles } from "../DataProvider/CalenderGroupContext/CalenderGroupContext";
import { FormattedEvent } from '../../../types';
import { PwaPullToRefresh } from "../PwaPullToRefresh/PwaPullToRefresh";
import './WeekView.css'

interface WeekViewProps {
  events?: FormattedEvent[]; 
  startDate: Date;
  onGoToSpecificWeek: (startDate: Date) => void;
  nextEventOutsideThisWeek?: FormattedEvent | null;
}

const WeekView: React.FC<WeekViewProps> = ({ 
  events = [],
  startDate,
  onGoToSpecificWeek,
  nextEventOutsideThisWeek = null
}) => {
  const { toggles } = useCalendarGroupToggles();

  // events defaults to [] so .forEach/.map are safe
  const days: Date[] = Array.from({ length: 7 }).map((_, i) => {
    const d = new Date(startDate);
    d.setDate(d.getDate() + i);
    return d;
  });

  // group events by date string
  const eventsByDay: Record<string, FormattedEvent[]> = {};

  events.forEach((ev) => {
    const key = new Date(ev.start).toDateString();
    if (!eventsByDay[key]) {
      eventsByDay[key] = [];
    }
    // filter by user setting from app menu
    // no toggle setting means toggle on
    if(!toggles.hasOwnProperty(ev.team?.Altersklasse) || toggles[ev.team?.Altersklasse]) {
      eventsByDay[key].push(ev);
      // store next event outside this week
      if (!nextEventOutsideThisWeek && new Date(ev.start) > days[6]) {
        nextEventOutsideThisWeek = ev;
      }
    }
  });

  // store if week is emtpy
  const isWeekEmpty = days.every((d) => {
    const key = d.toDateString();
    return !eventsByDay[key] || eventsByDay[key].length === 0;
  });

  return (
    <PwaPullToRefresh onRefresh={() => window.location.reload()}>
      <div className="week-view">
        {!isWeekEmpty? (
          <div className="day-column-container">
            {days.map((d) => {
              const key = d.toDateString();
              return <DayColumn key={key} date={d} events={eventsByDay[key] ?? []} isEmptyWeek={isWeekEmpty} />;
            })}
          </div>
        ) : (
          <div className="week-placeholder">
            <p>
              <SeasonIcon size={48} date={days[0]}/>
            </p>
            <p>
              <i>Keine Termine in dieser Woche</i>
            </p>
            { nextEventOutsideThisWeek &&
              <>
                <hr/>
                <p>
                  <i>
                    <span>Der n&#228;chste Termin ist </span>
                    <b>
                      <a onClick={ () => onGoToSpecificWeek(new Date(nextEventOutsideThisWeek!.start))} style={{cursor:'pointer'}}>
                        {nextEventOutsideThisWeek!.title}
                      </a>
                    </b> 
                    <span> am {new Date(nextEventOutsideThisWeek!.start).toLocaleDateString()}</span>
                  </i>
                </p>
              </>
            }
          </div>
        )}
      </div>
    </PwaPullToRefresh>
  );

};

export default WeekView;